import React from 'react';
import ReactDOM from 'react-dom';
import {Route, Link, BrowserRouter as Router} from 'react-router-dom';
import './index.css';

import App from './App';
import EbookDetail from './comps/EbookDetail';
import Library from './comps/Library';
import Search from './comps/Search';
import Registration from './comps/auth/Registration';
import Login from './comps/Login';
import * as serviceWorker from './serviceWorker';

import {createStore} from 'redux'

import allReducer from './reducers'
import { Provider } from 'react-redux'

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { PersistGate } from 'redux-persist/integration/react'

const persistConfig = {
    key: 'root',
    storage,
  }

const persistedReducer = persistReducer(persistConfig, allReducer)
const store = createStore(persistedReducer ,  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
const persistor = persistStore(store)

// persistor.purge() // just use this command to reset persist redux
// persistor.persist() 

const routing = (
    
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>
)

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

